// https://lbealjhg80.execute-api.us-east-1.amazonaws.com/dev2/coupons

import { useState, useEffect } from "react";
import axios from "axios";

const useFetchCoupons = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await axios.get("https://lbealjhg80.execute-api.us-east-1.amazonaws.com/dev2/coupons");
        setCoupons(response.data.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupons();
  }, []);

  return { coupons, loading, error };
};

export default useFetchCoupons;
